module.exports = __webpack_public_path__ + "img/40_38_034_910.567ad471.jpg";